module.exports = __webpack_public_path__ + "img/57.2.TN.958ff33a.png";